import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()

export class AddAcceptInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf('https://maps.googleapis.com') === -1) {
      request = request.clone({
        setHeaders: {
          Accept: `application/json`
        }
      });
    }

    return next.handle(request);
  }
}
